import ExtensibleError from '@atlassian/jira-extensible-error/src/index.tsx';

// Sentry is using ExtraErrorData integration to capture error data.
// We can enrich Error('Unknown error') with more details by just assigning
// to the error a new property and Sentry will capture it.
export class UnknownError extends ExtensibleError {
	name = 'UnknownError';

	details: unknown;

	constructor(message: string, details: unknown) {
		super(message);
		this.details = details;
	}
}
